<div
    class="search-popular-dropdown"
    [id]="idPrefix + '-search-listbox'"
    role="listbox"
    *ngIf="isOpen && popularSearches.length"
>
    <div class="dropdown-heading" *ngIf="showPopularHeading">Popular Right Now</div>
    <ul class="popular-list">
        <li
            *ngFor="let popularItem of popularSearches; let i = index"
            [id]="idPrefix + '-popular-option-' + i"
            class="popular-item selenium-{{ slugify(popularItem) }}"
            role="option"
            [attr.aria-selected]="i === activeIndex"
            [class.active]="i === activeIndex"
            [class.last-smart-suggestion]="isLastSuggestion(i)"
            (mousedown)="$event.preventDefault()"
            (click)="onSelect(popularItem)"
        >
            {{ capitalizeFirstLetter(popularItem) }}
        </li>
    </ul>
</div>
